var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative locations-page"},[(!_vm.$getState('showGoogleMap') && !_vm.$getState('showAppFilters') && _vm.isLocations)?_c('div',{staticClass:"px30 pt30"},[_c('router-link',{staticClass:"table",attrs:{"to":{
      path: '/dashboard'
    }}},[_c('Close',{attrs:{"icon":"back"}})],1)],1):_vm._e(),_vm._v(" "),_c('Post',{attrs:{"post-type":"partner","appTitle":_vm.appTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }